import { useEffect } from 'react';
import {
  connectNotificationSocket,
  disconnectNotificationSocket,
} from '../utils/notificationSocket';

/** Giriş yapıldığında WebSocket bildirim kanalını açar. */
export default function NotificationSocketBridge() {
  useEffect(() => {
    const t = setTimeout(() => connectNotificationSocket(), 300);
    return () => {
      clearTimeout(t);
      disconnectNotificationSocket();
    };
  }, []);
  return null;
}
